import isNil from 'lodash/isNil';
import type { ApiGetWorkflowResponseWithUsages } from '@jira/project-settings__workflow-types/src/WorkflowErrorCause.types.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { CloudId } from '@atlassian/jira-shared-types/src/general.tsx';

export const getApiPrefix = () => 'gateway/api/jira/project-configuration';

export const constructEndpoint = (cloudId: string) =>
	`/${getApiPrefix()}/query/${cloudId}/3/workflow`;

type WorkflowIdentifier = {
	workflowId?: string;
	workflowName?: string;
	projectAndIssueType?: {
		projectId: string;
		issueTypeId: string;
	};
};

type GetWorkflowPayload = {
	workflowIds?: [string];
	workflowNames?: [string];
	projectAndIssueTypes?: [
		{
			projectId: string;
			issueTypeId: string;
		},
	];
	skipUsageLookup?: boolean;
	checkForDrafts?: boolean;
};

export type GetWorkflowConfigOptions = { checkForDrafts: boolean };

export const getWorkflow = (
	cloudId: CloudId,
	workflowIdentifier: WorkflowIdentifier,
	config?: GetWorkflowConfigOptions,
): Promise<ApiGetWorkflowResponseWithUsages> => {
	const url = constructEndpoint(cloudId);
	const { workflowId, workflowName, projectAndIssueType } = workflowIdentifier;

	const payload: GetWorkflowPayload = {
		skipUsageLookup: false,
	};

	if (!isNil(workflowId)) {
		payload.workflowIds = [workflowId];
	}

	if (!isNil(workflowName)) {
		payload.workflowNames = [workflowName];
	}

	if (!isNil(projectAndIssueType)) {
		payload.projectAndIssueTypes = [projectAndIssueType];
	}

	if (config?.checkForDrafts && fg('hix-6846-discard-wfl-drafts-on-update')) {
		payload.checkForDrafts = true;
	}

	return performPostRequest(url, {
		body: JSON.stringify(payload),
	});
};
